import { render, staticRenderFns } from "./InstockTranSel.vue?vue&type=template&id=36b9303e&scoped=true&"
import script from "./InstockTranSel.vue?vue&type=script&lang=js&"
export * from "./InstockTranSel.vue?vue&type=script&lang=js&"
import style0 from "./InstockTranSel.vue?vue&type=style&index=0&id=36b9303e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b9303e",
  null
  
)

export default component.exports